import { SectionalBarList, type SectionalBarListProps } from "./SectionalBarList";

interface SimpleBarListProps {
	data: { label: string; value: number }[];
	colors: string[];
	maxVal: number;
	icon?: "country";
	getRowAction?: SectionalBarListProps["getRowAction"];
}

export const SimpleBarList = ({ data, colors, maxVal, icon, getRowAction }: SimpleBarListProps) => <SectionalBarList
	data={data.map(row => ({ ...row, value: [row.value] }))} colors={colors}
	maxTotal={maxVal} longLabels single icon={icon} getRowAction={getRowAction} />;
